import React from 'react';
import ReactDOM from 'react-dom';
import Datacandy from './datacandy';
import PunchCard from './punch-card';
import Shift8Points from './shift8-points';

const { Order } = Mobi2Go;

Order.onReady(() => {
    ReactDOM.render(
        <PunchCard is_showing_in_confirmation={false} />,
        document.querySelector('[data-view="order-punch-card"]')
    );

    ReactDOM.render(
        <Shift8Points />,
        document.querySelector('[data-view="shift8-points"]')
    );

    ReactDOM.render(
        <Datacandy />,
        document.querySelector('[data-view="datacandy"]')
    );
});
